module.exports = __webpack_public_path__ + "img/btn.dc4118b5.png";